import { defineComponent, reactive, ref, toRefs } from "vue";
import { MaterialTableService as ContractMaterialService } from "@/views/subcontract-management";
import { columns } from "./subcontract-material-select.constant";

/**
 * 从合同中选择材料清单
 */
export default defineComponent({
  name: "SubContractMaterialSelect",
  props: {
    contractId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  emits: ["ok"],
  setup(props, { emit }) {
    const visible = ref(false);
    const queryRef = reactive({ materialName: "" });
    const { data: dataSource, loading, run } = ContractMaterialService.useQuantityListApi();

    const showModal = async () => {
      if (props.projectId) {
        await run(props.projectId, queryRef.materialName);
      }
      visible.value = true;
    };

    const closeModal = () => {
      visible.value = false;
      queryRef.materialName = ""
    };
    const search = () => {
      showModal();
    };
    const ok = () => {
      if (selectedIds.value.length) {
        const materials = (dataSource.value?.records || []).filter((item) =>
          selectedIds.value.includes(item.id)
        );
        emit("ok", materials);
      }
      closeModal();
    };

    const selectedIds = ref<string[]>([]);
    const onSelectionChange = (ids: string[]) => {
      selectedIds.value = ids;
    };

    return {
      visible,
      showModal,
      closeModal,
      ok,
      queryRef,
      loading,
      dataSource,
      columns,
      selectedIds,
      onSelectionChange,
      search,
    };
  },
});
